module.exports = __webpack_public_path__ + "img/Frame_48.3d528864.png";